import { api } from './client';

/**
 * The optional account: an email address on the player's game, and sign-in
 * links. Asking for a link answers the same whether or not the address has
 * an account.
 */

export interface Account {
  email: string;
  marketingOptIn: boolean;
}

export interface AccountStatus {
  /** Accounts can be offered (the server can email links). */
  available: boolean;
  account: Account | null;
}

export interface SignInResult {
  playerId: string;
  /** This device's new token; null when it already plays as the player. */
  token: string | null;
  email: string;
  /** The link created the account. */
  created: boolean;
}

export function fetchAccountStatus(playerId: string): Promise<AccountStatus> {
  return api<AccountStatus>(`/players/${encodeURIComponent(playerId)}/account`);
}

/** Email a link to `email`. Throws ApiError 400 (not an address), 429 (too
 *  many links lately) or 503 (accounts are off). */
export async function requestSignInLink(email: string, marketingOptIn: boolean): Promise<void> {
  await api('/accounts/link', { method: 'POST', body: JSON.stringify({ email, marketingOptIn }) });
}

/** Follow a link. Throws ApiError 400 when it was used or ran out. */
export function followSignInLink(token: string): Promise<SignInResult> {
  return api<SignInResult>('/accounts/sign-in', { method: 'POST', body: JSON.stringify({ token }) });
}

export function setMarketingOptIn(playerId: string, optIn: boolean): Promise<Account> {
  return api<Account>(`/players/${encodeURIComponent(playerId)}/account/marketing`, {
    method: 'PUT',
    body: JSON.stringify({ optIn }),
  });
}
